<template>
  <div class="row h-100">
    <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
    <div class="col s12 h-100" style="overflow:auto">
      <div class="container">
        <div class="row mt-4" style="height:370px">
          <!-- <div class="col s12 m4 l4 h-100">
            <div class="card animate fadeLeft h-100 m-0">
              <div class="card-content">
                <h4 class="card-title mb-0">
                  Total Balance
                </h4>
                <div class="current-balance-container">
                  <div id="current-balance-donut-chart" class="current-balance-shadow"></div>
                </div>
                <h5 class="center-align">{{dashBoardDetails.total_revenue | currency}}</h5>
                <p class="medium-small center-align">Total balance till now</p>
              </div>
            </div>
          </div> -->
          <div class="col s12 m12 l12 animate fadeRight h-100">
            <!-- Total Transaction -->
            <div class="card h-100 m-0">
              <div class="card-content">
                <h4 class="card-title mb-0">
                  Total Transaction
                </h4>
                <p class="medium-small">This month transaction</p>
                <div class="total-transaction-container">
                  <div id="total-transaction-line-chart" class="total-transaction-shadow"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--/ Current balance & total transactions cards-->
        <!-- User statistics & appointment cards-->
        <div class="row mt-4" style="height:370px">
          <div class="col s12 l5 h-100">
            <div class="card user-statistics-card animate fadeLeft h-100 m-0">
              <div class="card-content">
                <h4 class="card-title mb-0">
                  User Statistics
                </h4>
                <div class="row">
                  <div class="col s12 m6">
                    <ul class="collection border-none mb-0">
                      <li class="collection-item avatar">
                        <i class="material-icons circle accent-2" style="background:#04b48d">credit_card</i>
                        <p class="medium-small">Bookings</p>
                      </li>
                    </ul>
                  </div>
                  <div class="col s12 m6">
                    <ul class="collection border-none mb-0">
                      <li class="collection-item avatar">
                        <i class="material-icons circle accent-4" style="background:#618BD5">group_work</i>
                        <p class="medium-small">Audits</p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="user-statistics-container">
                  <div id="user-statistics-bar-chart" class="user-statistics-shadow"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col s12 l4 h-100">
            <!-- Recent Buyers -->
            <div class="card recent-buyers-card animate fadeUp h-100 m-0">
              <div class="card-content">
                <h4 class="card-title mb-0">
                  Recent Users
                </h4>
                <ul class="collection mb-0">
                  <li
                    v-for="user in dashBoardDetails.recent_users"
                    :key="user.id"
                    class="collection-item avatar"
                  >
                    <div class="circle flex-center">{{user.short_name}}</div>
                    <p class="font-weight-600">{{user.first_name}}</p>
                    <p class="medium-small">{{user.date_joined | date('DD MMMM YYYY')}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col s12 l3 h-100">
            <div class="card animate fadeRight h-100 m-0">
              <div class="card-content">
                <h4 class="card-title mb-0">Conversion Ratio</h4>
                <div class="conversion-ration-container mt-8">
                  <div id="conversion-ration-bar-chart" class="conversion-ration-shadow"></div>
                </div>
                <div class="hints">
                  <div class="hint">
                    <div class="dot-hint"></div>
                    <div class="dot-desc">All Users</div>
                  </div>
                  <div class="hint">
                    <div class="dot-hint cuser"></div>
                    <div class="dot-desc">Converted Users</div>
                  </div>
                </div>
                <p class="medium-small center-align">Total conversion ratio</p>
                <h5
                  class="center-align mb-0 mt-3"
                >{{dashBoardDetails.conversion_ratio ? dashBoardDetails.conversion_ratio.user_ratio : ""}}%</h5>
              </div>
            </div>
          </div>
        </div>
        <!--/ Current balance & appointment cards-->
        <div class="row mt-4">
          <!-- <div class="col s12 m6 l4">
              <div class="card padding-4 animate fadeLeft">
                <div class="col s5 m5">
                  <h5 class="mb-0">1885</h5>
                  <p class="no-margin">New</p>
                  <p class="mb-0 pt-8">1,12,900</p>
                </div>
                <div class="col s7 m7 right-align">
                  <i class="material-icons background-round mt-5 mb-5 gradient-45deg-purple-amber gradient-shadow white-text">perm_identity</i>
                  <p class="mb-0">Total Clients</p>
                </div>
              </div>
              <div id="chartjs" class="card pt-0 pb-0 animate fadeLeft">
                <div class="padding-2 ml-2">
                  <span class="new badge gradient-45deg-indigo-purple gradient-shadow mt-2 mr-2">+ $900</span>
                  <p class="mt-2 mb-0 font-weight-600">Today's revenue</p>
                  <p class="no-margin grey-text lighten-3">$40,512 avg</p>
                  <h5>$ 22,300</h5>
                </div>
                <div class="row">
                  <div class="sample-chart-wrapper card-gradient-chart">
                    <canvas id="custom-line-chart-sample-three" class="center"></canvas>
                  </div>
                </div>
              </div>
          </div>-->
          <div class="col s12 m12 l12">
            <div class="card subscriber-list-card animate fadeRight mt-0">
              <div class="card-content pb-1">
                <h4 class="card-title mb-0">
                  Recent Vendors
                </h4>
              </div>
              <table class="subscription-table responsive-table highlight">
                <thead>
                  <tr>
                    <th>Rep ID</th>
                    <th>Rep Name</th>
                    <th>Company Name</th>
                    <th>Mobile Number</th>
                    <th>Date of Joining</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="vendor in dashBoardDetails.recent_vendors" :key="vendor.id">
                    <td>{{vendor.business_details ? vendor.business_details.rep_id : ""}}</td>
                    <td>{{vendor.first_name}}</td>
                    <td>{{vendor.business_details ? vendor.business_details.business_name : ""}}</td>
                    <td>{{vendor.mobile_number}}</td>
                    <td>{{vendor.date_joined | date('ddd, DD MMM YYYY hh:mm a')}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dashBoardDetails: {
        total_revenue: 0,
        conversion_ratio: {
          user_ratio: 0,
          all_users: 0,
          converted_users: 0
        }
      },
      statistics: {
        labels: [],
        series: [[], []]
      }
    };
  },
  created() {
    this.initJS();
    this.retriveDetails();
  },
  methods: {
    initJS() {
      setTimeout(() => {
        var leftnav = $(".page-topbar").height();
        var leftnavHeight = window.innerHeight - leftnav;
        var righttnav = $("#slide-out-right").height();

        if ($("#slide-out.leftside-navigation").length > 0) {
          if (!$("#slide-out.leftside-navigation").hasClass("native-scroll")) {
            var ps_leftside_nav = new PerfectScrollbar(".leftside-navigation", {
              wheelSpeed: 2,
              wheelPropagation: false,
              minScrollbarLength: 20
            });
          }
        }
        if ($(".slide-out-right-body").length > 0) {
          var ps_slideout_right = new PerfectScrollbar(
            ".slide-out-right-body, .chat-body .collection",
            {
              suppressScrollX: true
            }
          );
        }
        if ($(".chat-body .collection").length > 0) {
          var ps_slideout_chat = new PerfectScrollbar(
            ".chat-body .collection",
            {
              suppressScrollX: true
            }
          );
        }

        // Char scroll till bottom of the char content area
        var chatScrollAuto = $(
          "#right-sidebar-nav #slide-out-chat .chat-body .collection"
        );
        if (chatScrollAuto.length > 0) {
          chatScrollAuto[0].scrollTop = chatScrollAuto[0].scrollHeight;
        }
        $(".dropdown-trigger").dropdown();
      }, 500);
    },
    initChart() {
      // var CurrentBalanceDonutChart = new Chartist.Pie(
      //   "#current-balance-donut-chart",
      //   {
      //     labels: [1, 2],
      //     series: [
      //       { meta: "Completed", value: 80 },
      //       { meta: "Remaining", value: 20 }
      //     ]
      //   },
      //   {
      //     donut: true,
      //     donutWidth: 8,
      //     showLabel: false,
      //     plugins: [
      //       Chartist.plugins.tooltip({
      //         class: "current-balance-tooltip",
      //         appendToBody: true
      //       }),
      //       Chartist.plugins.fillDonut({
      //         items: [
      //           {
      //             content: `<p class="small">Balance</p><h5 class="mt-0 mb-0">₹ ${this.abbreviateNumber(
      //               this.dashBoardDetails.total_revenue
      //             )}</h5>`
      //           }
      //         ]
      //       })
      //     ]
      //   }
      // );

      // Total Transaction
      // -----------------
      let tempArr = JSON.parse(
        JSON.stringify(this.dashBoardDetails.this_month_bookings)
      );
      let largestNum = tempArr
        .sort(function(a, b) {
          return a - b;
        })
        .reverse()[0];
      let labels = [],
        series;
      this.dashBoardDetails.this_month_bookings.forEach((val, key) => {
        labels.push(key + 1);
      });
      series = [99, 34, 101, 65, 21, 2, 89, 91, 54, 2, 33, 64, 59, 38, 38, 5, 29, 65, 53, 19, 44, 8, 76, 82, 78, 2];
      var TotalTransactionLine = new Chartist.Line(
        "#total-transaction-line-chart",
        {
          labels: labels,
          series: [series]
          // series: [[99, 34, 101, 65, 21, 2, 89, 91, 54, 2, 33, 64, 59, 38, 38, 5, 29, 65, 53, 19, 44, 8, 76, 82, 78, 2]]
        },
        {
          chartPadding: 0,
          axisX: {
            showLabel: true,
            showGrid: false
          },
          axisY: {
            showLabel: true,
            showGrid: true
            // low: 0,
            // high: largestNum + 20,
            // scaleMinSpace: 40
          },
          lineSmooth: Chartist.Interpolation.simple({
            divisor: 2
          }),
          // plugins: [
          //   Chartist.plugins.tooltip(
          //   // {
          //   //   class: "total-transaction-tooltip",
          //   //   appendToBody: true,
          //   //   transformTooltipTextFnc: function(tooltip) {
          //   //     console.log(tooltip);
          //   //     var xy = tooltip.split(",");
          //   //     return xy[1];
          //   //   }
          //   // }
          //   )
          // ],
          fullWidth: true
        }
      );

      TotalTransactionLine.on("created", function(data) {
        var defs = data.svg.querySelector("defs") || data.svg.elem("defs");
        defs
          .elem("linearGradient", {
            id: "lineLinearStats",
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 0
          })
          .elem("stop", {
            offset: "0%",
            "stop-color": "rgba(255, 82, 249, 0.1)"
          })
          .parent()
          .elem("stop", {
            offset: "10%",
            "stop-color": "rgba(255, 82, 249, 1)"
          })
          .parent()
          .elem("stop", {
            offset: "30%",
            "stop-color": "rgba(255, 82, 249, 1)"
          })
          .parent()
          .elem("stop", {
            offset: "95%",
            "stop-color": "rgba(133, 3, 168, 1)"
          })
          .parent()
          .elem("stop", {
            offset: "100%",
            "stop-color": "rgba(133, 3, 168, 0.1)"
          });

        return defs;
      }).on("draw", function(data) {
        var circleRadius = 5;
        if (data.type === "point") {
          var circle = new Chartist.Svg("circle", {
            cx: data.x,
            cy: data.y,
            "ct:value": data.y,
            r: circleRadius,
            class:
              data.value.y === 35
                ? "ct-point ct-point-circle"
                : "ct-point ct-point-circle-transperent"
          });
          data.element.replace(circle);
        }
      });

      // User Statics
      var UserStatisticsBarChart = new Chartist.Bar(
        "#user-statistics-bar-chart",
        {
          labels: this.statistics.labels,
          series: this.statistics.series
        },
        {
          stackBars: true,
          chartPadding: 0,
          axisX: {
            showGrid: false
          },
          axisY: {
            showGrid: false,
            labelInterpolationFnc: function(value) {
              return Math.ceil(value / 1000) + "k";
            },
            scaleMinSpace: 50
          },
          plugins: [
            Chartist.plugins.tooltip({
              class: "user-statistics-tooltip",
              appendToBody: true,
              transformTooltipTextFnc: function(tooltip) {
                return `₹ ${tooltip}`;
              }
            })
          ]
        },
        [
          // Options override for media > 800px
          [
            "screen and (min-width: 800px)",
            {
              stackBars: false,
              seriesBarDistance: 10
            }
          ],
          // Options override for media > 1000px
          [
            "screen and (min-width: 1000px)",
            {
              reverseData: false,
              horizontalBars: false,
              seriesBarDistance: 15
            }
          ]
        ]
      );

      UserStatisticsBarChart.on("draw", function(data) {
        if (data.type === "bar") {
          data.element.attr({
            style: "stroke-width: 12px",
            x1: data.x1 + 0.001
          });
          data.group.append(
            new Chartist.Svg(
              "circle",
              {
                cx: data.x2,
                cy: data.y2,
                r: 6
              },
              "ct-slice-pie"
            )
          );
          data.element.animate({
            y2: {
              begin: 500,
              dur: 500,
              from: data.y1,
              to: data.y2
            }
          });
        }
      });

      UserStatisticsBarChart.on("created", function(data) {
        var defs = data.svg.querySelector("defs") || data.svg.elem("defs");
        defs
          .elem("linearGradient", {
            id: "barGradient1",
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          })
          .elem("stop", {
            offset: 0,
            "stop-color": "rgba(255,75,172,1)"
          })
          .parent()
          .elem("stop", {
            offset: 1,
            "stop-color": "rgba(255,75,172, 0.6)"
          });

        defs
          .elem("linearGradient", {
            id: "barGradient2",
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          })
          .elem("stop", {
            offset: 0,
            "stop-color": "rgba(129,51,255,1)"
          })
          .parent()
          .elem("stop", {
            offset: 1,
            "stop-color": "rgba(129,51,255, 0.6)"
          });
        return defs;
      });

      // Conversion Ratio
      let all_users = this.dashBoardDetails.conversion_ratio.all_users;
      let converted_users = this.dashBoardDetails.conversion_ratio
        .converted_users;
      var ConversionRatioBarChart = new Chartist.Bar(
        "#conversion-ration-bar-chart",
        {
          labels: ["Q1"],
          series: [[all_users], [converted_users]]
        },
        {
          stackBars: true,
          chartPadding: {
            top: 0,
            right: 50,
            bottom: 0,
            left: 0
          },
          axisX: {
            showLabel: false,
            showGrid: false
          },
          axisY: {
            showGrid: false,
            labelInterpolationFnc: function(value) {
              if (value >= 1000) {
                return value / 1000 + "k";
              }
              return value;
            }
          },
          plugins: [
            Chartist.plugins.tooltip({
              class: "user-statistics-tooltip",
              appendToBody: true
            })
          ]
        }
      );
      ConversionRatioBarChart.on("draw", function(data) {
        if (data.type === "bar") {
          data.element.attr({
            style: "stroke-width: 40px",
            x1: data.x1 + 0.001
          });
          data.group.append(
            new Chartist.Svg("circle", {
              cx: data.x2,
              cy: data.y2
            })
          );

          data.element.animate({
            y2: {
              begin: 500,
              dur: 500,
              from: data.y1,
              to: data.y2,
              easing: Chartist.Svg.Easing.easeInBounce
            }
          });
        }
      });

      ConversionRatioBarChart.on("created", function(data) {
        var defs = data.svg.querySelector("defs") || data.svg.elem("defs");
        defs
          .elem("linearGradient", {
            id: "barGradient1",
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          })
          .elem("stop", {
            offset: 0,
            "stop-color": "rgba(129,51,255,1)"
          })
          .parent()
          .elem("stop", {
            offset: 1,
            "stop-color": "rgba(129,51,255, 0.6)"
          });

        defs
          .elem("linearGradient", {
            id: "barGradient2",
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          })
          .elem("stop", {
            offset: 0,
            "stop-color": "rgba(255,75,172,1)"
          })
          .parent()
          .elem("stop", {
            offset: 1,
            "stop-color": "rgba(255,75,172, 0.6)"
          });
        return defs;
      });

      //Sampel Line Chart Three

      // Options
      var SLOption = {
        responsive: true,
        maintainAspectRatio: true,
        datasetStrokeWidth: 3,
        pointDotStrokeWidth: 4,
        tooltipFillColor: "rgba(0,0,0,0.6)",
        legend: {
          display: false,
          position: "bottom"
        },
        hover: {
          mode: "label"
        },
        scales: {
          xAxes: [
            {
              display: false
            }
          ],
          yAxes: [
            {
              display: false
            }
          ]
        },
        title: {
          display: false,
          fontColor: "#FFF",
          fullWidth: false,
          fontSize: 40,
          text: "82%"
        }
      };
      var SLlabels = ["January", "February", "March", "April", "May", "June"];

      if (document.getElementById("custom-line-chart-sample-three")) {
        var LineSL3ctx = document
          .getElementById("custom-line-chart-sample-three")
          .getContext("2d");

        var gradientStroke = LineSL3ctx.createLinearGradient(500, 0, 0, 200);
        gradientStroke.addColorStop(0, "#8133ff");
        gradientStroke.addColorStop(1, "#ff4bac");

        var gradientFill = LineSL3ctx.createLinearGradient(500, 0, 0, 200);
        gradientFill.addColorStop(0, "#8133ff");
        gradientFill.addColorStop(1, "#ff4bac");

        var SL3Chart = new Chart(LineSL3ctx, {
          type: "line",
          data: {
            labels: SLlabels,
            datasets: [
              {
                label: "My Second dataset",
                borderColor: gradientStroke,
                pointColor: "#fff",
                pointBorderColor: gradientStroke,
                pointBackgroundColor: "#fff",
                pointHoverBackgroundColor: gradientStroke,
                pointHoverBorderColor: gradientStroke,
                pointRadius: 4,
                pointBorderWidth: 1,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 1,
                fill: true,
                backgroundColor: gradientFill,
                borderWidth: 1,
                data: [24, 18, 20, 30, 40, 43]
              }
            ]
          },
          options: SLOption
        });
      }
    },
    retriveDetails() {
      this.isLoader = true;
      ajax.get(
        Constants.default.APIURL.Dashboard,
        res => {
          this.dashBoardDetails = res.data;
          this.getUserStaticsDetails();
          setTimeout(() => {
            this.initChart();
            this.isLoader = false;
          }, 600);
        },
        err => {
          this.isLoader = false;
        }
      );
    },
    abbreviateNumber(value) {
      var newValue = value;
      if (value >= 1000) {
        var suffixes = ["", "k", "m", "b", "t"];
        var suffixNum = Math.floor(("" + value).length / 3);
        var shortValue = "";
        for (var precision = 2; precision >= 1; precision--) {
          shortValue = parseFloat(
            (suffixNum != 0
              ? value / Math.pow(1000, suffixNum)
              : value
            ).toPrecision(precision)
          );
          var dotLessShortValue = (shortValue + "").replace(
            /[^a-zA-Z 0-9]+/g,
            ""
          );
          if (dotLessShortValue.length <= 2) {
            break;
          }
        }
        // if (shortValue % 1 != 0)  shortNum = shortValue.toFixed(1);
        newValue = shortValue + suffixes[suffixNum];
      }
      return newValue;
    },

    getUserStaticsDetails() {
      let statisticsDetail = this.dashBoardDetails.last_six_months_revenue;
      statisticsDetail.forEach(val => {
        let monthName = new Date(new Date().setMonth(val.month - 1))
          .toString()
          .split(" ")[1];
        this.statistics.labels.push(monthName);
        this.statistics.series[0].push(val.bookings);
        this.statistics.series[1].push(val.audits);
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../../public/assets/css/pages/dashboard.css";
.flex-center {
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}

.user-statistics-card .collection .collection-item {
  min-height: 70px !important;
  display: flex;
  align-items: center;
}
.collection .collection-item.avatar i.circle {
  font-size: 25px !important;
}
.recent-buyers-card .collection {
  border: none;
  max-height: 240px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.hints {
  .hint {
    text-align: left;
    font-size: 13px;
    display: flex;
    margin: 4px 0;
    .dot-hint {
      width: 15px;
      height: 15px;
      background: rgb(97, 139, 213);
    }
    .dot-hint.cuser {
      background: rgb(4, 180, 141);
    }
    .dot-desc {
      padding-left: 10px;
    }
  }
}
</style>